import { render, staticRenderFns } from "./repeat_data_handler_cardcode.vue?vue&type=template&id=bf8eed6e&scoped=true&"
import script from "./repeat_data_handler_cardcode.vue?vue&type=script&lang=tsx&"
export * from "./repeat_data_handler_cardcode.vue?vue&type=script&lang=tsx&"
import style0 from "./repeat_data_handler_cardcode.vue?vue&type=style&index=0&id=bf8eed6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8eed6e",
  null
  
)

export default component.exports